const cellularTypes = ["WaterMeter", "Sentree", "Hubbie", "SumpPit"]
export default cellularTypes;